// Keeps track of the number of requests happening at any given time.
// Some questions for the future:
//   - How do we know if a request for creating a line item is happening?
//   - Some unrelated request may be showing a loading bar, confusing the user. How to avoid this?
export default function activeRequests(state = 0, action) {
  if (action.type === 'START_REQUEST') {
    return state + 1
  }

  if (action.type === 'FINISH_REQUEST') {
    return state - 1
  }

  return state
}
